import { createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_close.svg'


const _hoisted_1 = {
  class: "relative inline-block",
  ref: "filterContainer"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: " w-5 h-5 mr-4",
  style: {"min-width":"20px"}
}, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "absolute mt-2 bg-white rounded-lg shadow-lg z-50 min-w-[300px] max-w-[400px]"
}
const _hoisted_4 = { class: "p-3 border-b" }
const _hoisted_5 = { class: " text-gray-lp-300 text-sm font-semibold" }
const _hoisted_6 = { class: "flex justify-around gap-2 p-3 border-t" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      class: [_ctx.filterButtonClass, "rounded-full min-w-max px-4 py-2 text-sm font-semibold flex items-center gap-2 min-w-fit whitespace-nowrap transition-colors"],
      onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleFilterToggle && _ctx.handleFilterToggle(...args)), ["stop"]))
    }, [
      _createVNode("img", {
        src: _ctx.currentFilterIcon,
        class: "w-5 h-5",
        alt: `${_ctx.filterLabel} icon`
      }, null, 8, ["src", "alt"]),
      _createVNode("span", null, _toDisplayString(_ctx.filterButtonText), 1),
      (_ctx.hasSelection || _ctx.isFilterOpen)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleClearSelection && _ctx.handleClearSelection(...args)), ["stop"])),
            class: "ml-1 cursor-pointer hover:opacity-80",
            "aria-label": "Clear selection",
            title: "Clear"
          }, [
            _hoisted_2
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.isFilterOpen)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t('dashboard.breakdownFilter.select')) + " " + _toDisplayString(_ctx.filterLabel.toLowerCase()), 1)
          ]),
          _createVNode("div", {
            class: "max-h-[400px] h-40 overflow-y-auto",
            onScroll: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
          }, [
            _createVNode(_component_MultipleSelectSearch, {
              "data-select": _ctx.dataSelectItems,
              "options-by-search": _ctx.optionsBySearchItems,
              "is-open-menu": _ctx.isFilterOpen,
              "is-disabled": false,
              "is-loading": _ctx.isLoading,
              placeholder: _ctx.$t('dashboard.breakdownFilter.searchHere', { label: _ctx.filterLabel.toLowerCase() }),
              "on-open-select": _ctx.handleOpenSelect,
              "on-close-select": _ctx.noop,
              "on-choose-select": _ctx.handleChooseSelect,
              "on-typing": _ctx.handleSearchTyping,
              "on-search": _ctx.handleSearchTyping,
              "on-scroll": _ctx.handleScroll,
              "max-height": 360,
              showSearchInput: _ctx.showSearchInput
            }, null, 8, ["data-select", "options-by-search", "is-open-menu", "is-loading", "placeholder", "on-open-select", "on-close-select", "on-choose-select", "on-typing", "on-search", "on-scroll", "showSearchInput"])
          ], 32),
          _createVNode("div", _hoisted_6, [
            _createVNode("button", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleReset && _ctx.handleReset(...args))),
              class: ["px-4 py-2 hover:bg-gray-100 font-semibold text-xs rounded", _ctx.applyTextClass]
            }, _toDisplayString(_ctx.$t('dashboard.breakdownFilter.reset')), 3),
            _createVNode("button", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleApply && _ctx.handleApply(...args))),
              class: [_ctx.applyButtonClass, "px-4 py-2  text-white font-semibold rounded-md text-xs transition-colors"]
            }, _toDisplayString(_ctx.$t('dashboard.breakdownFilter.apply')), 3)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512))
}